/*
 * @Author: 李嘉宾 lijb@wisea.com.cn
 * @Date: 2024-07-24 10:57:32
 * @LastEditors: 李嘉宾 lijb@wisea.com.cn
 * @LastEditTime: 2024-08-27 15:30:24
 * @FilePath: \web\sznc_buyer\src\assets\js\api\dealhome.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
let Api = { 
	"SHOPCART_SUBMITORDER": "/b2b/w/shopCart/submitOrder", //提交订单：商品skuId列表
	"SHOPCART_CONFIRMORDER": "/b2b/w/shopCart/confirmOrder", //确认订单：入参购物车id列表/商品skuId
	"ADDRESS_DEFAULTFLAG": "/b2b/w/address/defaultFlag", //查询默认收货地址
	"SHOPHOME_FINDSHOPINFO": "/b2b/n/ShopHome/findShopInfo", //查询默认收货地址
	"BUYERORDER_REATEPAYURL": "/b2b/w/buyerOrder/createPayUrl", //获取支付链接的接口
	"ORDER_FINDSHOPORDERINFO": "/b2b/w/order/findShopOrderInfo", //查询店铺订商单详细信息
	"ENTPAUTH_GETBANKACCOUNTBYID": "/system/w/merchantAuth/getBankAccountById", //商家银行信息
	"ORDER_OFFLINEPAY": "/b2b/w/buyerOrder/offlinePay", //【订单】订单线下支付
	"APPAYMAGE_FINDAPPAYMAGEBYSELLERID": "/b2b/w/apPayMage/findApPayMageBySellerId", //可用额度
	"PERSON_VALIDATEPAYPASSWORD": "/b2b/w/person/validatePayPassword", //提交付款密码
	"BUYERORDER_ACCOUNTPAY": "/b2b/w/buyerOrder/accountPay", //账期支付
	"SETTLEBILL_OFFLINEPAY": "/b2b/w/buyer/settleBill/offlinePay", //买家端 - 结算单线下支付(保存)
	"N_SYSTEMCONFIG_GETREGPROTOCOLINFO": "/b2b/n/systemConfig/getRegProtocolInfo", //协议配置详细信息
	"N_SYSTEMCONFIG_GETWEBBASECONFIG": "/b2b/n/systemConfig/getWebBaseConfig", //网站配置信息
	"N_SYSTEMCONFIG_GETWEBBASEPICCONFIG":"/b2b/n/systemConfig/getWebBasePicConfig", //网站图片配置
	"N_INDUSTRYARTICLECLASSMAGE_FINDINDUSTRYARTICLECLASSMAGETREE":"/b2b/n/industryArticleClassMage/findIndustryArticleClassMageTree", //查询基础品类树
	"N_INDUSTRYARTICLEMAGE_FINDPAGELIST":"/b2b/n/industryArticleMage/findPageList", //产业文章管理分页查询列表
	"N_INDUSTRYARTICLEMAGE_FINDINFO":"/b2b/n/industryArticleMage/findInfo", //产业文章管理查询详细信息
	"B2B_N_MANAGE_FINDDEFAULT": "/b2b/n/manage/findDefault", //查询默认产业基本信息
	"B2B_N_INDUSTRYFRIENDLYLINKMANAGE_FINDLIST": "/b2b/n/IndustryFriendlyLinkManage/findList", //友情链接查询列表
	"B2B_N_MODULE_FINDLIST": "/b2b/n/module/findPageList", //内容管理和关于我们模块分页查询列表
	"B2B_N_MODULE_FINDINFO": "/b2b/n/module/findInfo", //内容管理和关于我们模块分页查询
	"N_INDUSTRYMODULEMAGE_FINDINFO": "/portal-api/n/IndustryModuleMage/findInfo", //内容管理和关于我们模块分页查询 门户
	"N_INDUSTRYMODULEMAGE_FINDPAGELIST": "/portal-api/n/IndustryModuleMage/findPageList", //内容管理和关于我们模块分页查询 门户
	"N_INDUSTRYMODULEMAGE_FINDPAGELIST": "/portal-api/n/IndustryModuleMage/findPageList", //内容管理和关于我们模块分页查询 门户
  
	"INDUSTRYLMODULECONTENT_FINDLIST": "/portal-api/n/IndustrylModuleContent/findList", //内容管理和关于我们模块 内容查询列表
	"B2B_N_CONTENT_FINDLIST": "/b2b/n/content/findList", //内容管理和关于我们模块 内容查询列表
	"B2B_N_PORTAL_FINDDEFAULT": "/b2b/n/entpPortalMage/findDefault", //查询数字供销推广配置
  
  	"INDUSTRYMANGE_FINDDEFAULT": "/portal-api/n/IndustryMange/findDefault", //查询默认产业基本信息
	"B2B_W_STAT_SAVE": "/b2b/w/stat/save", //添加浏览记录
	"B2B_N_INDUSTRYCERTIFICATION_FINDALL": "/b2b/n/IndustryCertification/findList", //查询所有商务资质
	"B2B_N_SYSENTER_FINDLIST": "/b2b/n/IndustrySystemEntry/findList", //系统入口查询列表
	"B2B_N_SHOPCOMMCATG_FINDLIST": "/b2b/n/shopCommCatg/list", //查询店铺分类
	"B2B_N_COMMSALECATG_FINDLIST": "/b2b/n/commSaleCatg/list", //查询销售分类
    
	"BUYERORDER_ORDERPAYINITVO": "/b2b/w/buyerOrder/orderPayInitVo", //订单支付初始化
	"PROTAL_N_INDUSTRYFRIENDLY_FINDLIST": "/portal-api/n/IndustryFriendlyLinkManage/findList", //友情链接
	"PROTAL_N_INDUSTRYMODULE_FINDPAGELIST": "/portal-api/n/IndustryModuleMage/findPageList", // 关于我们
	"PROTAL_N_PROTOCOL_GETPROTOCOLINFO": "/portal-api/n/protocol/getProtocolInfo", // 协议配置
	"PROTAL_N_INDUSTRYCERTIFICATION_FINDLIST_TYPE": "/portal-api/n/IndustryCertification/findList", // 商务资质/公司主体
	"PROTAL_N_INDUSTRYMANGE_FINDDEFAULTBYTYPE": "/portal-api/n/IndustryMange/findDefaultByType", // 基础信息
    "B2B_N_PLAT_FINDDEFAULT": "/system/w/PlatInfoMage/findInfo", //查询平台基本信息
    "ENTPBASEMAGE_FINDLIST":"/difam/n/findEntpBaseList",//基地查询列表
	// 待办
    "B2B_BACKLOG":"/b2b/w/backlog/backlog",//我的待办

  
} 
module.exports = Api